import React, { Component } from 'react';


function TutorialText(props) {

		if (props.step === 1){
			return(
				<div className="step-1">
					<h3>Primero elige un fondo<br/> y un suelo para tu diseño.</h3>
				</div>
			)
		}
		if (props.step === 2){
			return(
				<div className="step-2" >				
					<h3>Elige un elemento,<br/> pincha sobre él, <br/>elige su tamaño y arrástralo <br/>al lugar del mapa que prefieras.</h3>
				</div>
			)
		}
	
}

export default class Tutorial extends Component {

	constructor(props) {
		super(props);
		this.state = { 		
			step : 1,
		
		};

		this.skip = this.skip.bind(this);
		this.steps = this.steps.bind(this);
		this.nextStep = this.nextStep.bind(this);
	}
	steps(){
		clearInterval(this.timerID);
		
    	/*this.timerID  = setTimeout(function() {    		
    		that.nextStep();  
        }, 5500); */ 
	}

	nextStep(){
		
		if (this.props.layout === 'home'){
			return false;
		}

		if (this.state.step === 2 ){
			this.skip();
			return false;
		}

		this.setState((prevState) => {
	      return {
	        step: prevState.step + 1,	        
	      }
	    });
	    this.steps();
	}


	skip(){
		location.href = '#/home'; 
	}

	skipTutorial(){

	}



	render() {
		return (
				<div className="tutorial-popup" onClick={this.nextStep}>
				
					<div className="container">
						<div className="display-t"><div className="display-tc">
							<div className="tutorial-step ">
								<TutorialText step={this.state.step} />
								
							</div>

						</div></div>
					</div>

					{
						(this.props.layout === 'tutorial') && 
						<div>
						{
						(this.state.step === 2)? 
						<a className="btn btn-brand btn-skip"><i className="fa fa-step-forward" aria-hidden="true"></i> Comenzar</a>
						:
						<a className="btn btn-brand btn-skip"><i className="fa fa-step-forward" aria-hidden="true"></i> Siguiente</a>
						}
						</div>
					}
				</div>


		
		);
	}
}



// WEBPACK FOOTER //
// ./src/TutorialPopup.js